export function toggleTabs(tablist, duration) {
  let i = 0;
  return setInterval(() => {
    jQuery(tablist[i]).click();
    i = (i + 1) % tablist.length;
  }, duration);
}

export function addAutoPlayForTabs(selector) {
  Array.from(document.querySelectorAll(selector)).forEach((slider) => {
    const sliderList = Array.from(
      slider.querySelectorAll('a[data-toggle="tab"]')
    );
    const intervalId = toggleTabs(sliderList, 3000);
    sliderList.forEach((tab) => {
      // need to use jquery to differentiate between user click and js click
      jQuery(tab).click((e) => {
        if (e.originalEvent) {
          clearInterval(intervalId);
        }
      });
    });
  });
}   